import DataExtractionService from '../../dataExtraction/DataExtractionService';
import UrlService from '../../UrlService';

import { createCRMMessageHandler } from './crmMessageHandler';

export const microsoftDynamicsMessageHandler = createCRMMessageHandler({
  isCompanyPage: UrlService.isMicrosoftDynamicsCompanyPage,
  isContactPage: UrlService.isMicrosoftDynamicsContactPage,
  isLeadPage: UrlService.isMicrosoftDynamicsLeadPage,
  extractionService: DataExtractionService.microsoftDynamics,
});
